import React from "react";

const ChevronRight = ({ fillColor = "currentColor", fillOpacity = "0.5" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2943 9.69817C10.2011 9.60626 10.1271 9.49673 10.0765 9.37596C10.026 9.25519 10 9.12559 10 8.99467C10 8.86376 10.026 8.73416 10.0765 8.61339C10.1271 8.49262 10.2011 8.38309 10.2943 8.29117C10.4833 8.10461 10.7382 8 11.0038 8C11.2694 8 11.5243 8.10461 11.7133 8.29117L14.6783 11.2312C14.7805 11.3325 14.8616 11.4531 14.917 11.5859C14.9723 11.7188 15.0008 11.8613 15.0008 12.0052C15.0008 12.1491 14.9723 12.2916 14.917 12.4244C14.8616 12.5573 14.7805 12.6778 14.6783 12.7792L11.7233 15.7092C11.5342 15.896 11.2791 16.0008 11.0133 16.0008C10.7475 16.0008 10.4924 15.896 10.3033 15.7092C10.2101 15.6173 10.1361 15.5077 10.0855 15.387C10.035 15.2662 10.009 15.1366 10.009 15.0057C10.009 14.8748 10.035 14.7452 10.0855 14.6244C10.1361 14.5036 10.2101 14.3941 10.3033 14.3022L12.6213 12.0052L10.2943 9.69817Z"
      fill={fillColor}
      fillOpacity={fillOpacity}
    />
  </svg>
);

export default ChevronRight;
